import { useLiveQuery } from 'dexie-react-hooks'
import { NavLink } from 'react-router'
import { Icon } from '../../components/Icon'
import { db, type LocalChannel } from '../../db/db'
import { isAdminRole, useSession } from '../../state/session'
import { totalUnread } from '../conversations/filterChannels'

const EMPTY: LocalChannel[] = []

/**
 * Where a thumb reaches: the app's sections along the bottom of a phone (spec §1.2). Shown on the list, search,
 * settings and administration; a conversation covers it, the way it covers the list.
 */
export function TabBar() {
  const me = useSession((s) => s.me)
  const isAdmin = isAdminRole(me)
  const pendingDevices = me?.pendingDeviceRequests ?? 0
  const channels = useLiveQuery(() => db.channels.toArray(), [], EMPTY)
  const unread = totalUnread(channels)

  return (
    <nav className="tab-bar" aria-label="Sections">
      <NavLink to="/" end className="tab" aria-label={unread > 0 ? `Chats, ${unread} unread` : 'Chats'}>
        <Icon name="message" />
        <span>Chats</span>
        {unread > 0 ? (
          <span className="badge tab-badge" aria-hidden="true">
            {unread > 99 ? '99+' : unread}
          </span>
        ) : null}
      </NavLink>
      <NavLink to="/search" className="tab" aria-label="Search messages">
        <Icon name="search" />
        <span>Search</span>
      </NavLink>
      {isAdmin ? (
        <NavLink
          to={pendingDevices > 0 ? '/admin/devices' : '/admin'}
          className="tab"
          aria-label={
            pendingDevices > 0
              ? `Administration, ${pendingDevices} ${pendingDevices === 1 ? 'device' : 'devices'} waiting for approval`
              : 'Administration'
          }
        >
          <Icon name="shield" />
          <span>Admin</span>
          {pendingDevices > 0 ? (
            <span className="badge tab-badge" aria-hidden="true">
              {pendingDevices > 99 ? '99+' : pendingDevices}
            </span>
          ) : null}
        </NavLink>
      ) : null}
      <NavLink to="/settings" className="tab" aria-label="Settings">
        <Icon name="settings" />
        <span>Settings</span>
      </NavLink>
    </nav>
  )
}
